// Funnel events for Vercel Web Analytics. Names are stable; check them under
// Analytics → Events in the Vercel project. Never throws, never blocks.
import { track as vercelTrack } from '@vercel/analytics';

export function track(name, props) {
  try {
    vercelTrack(name, props);
  } catch (e) {
    // analytics must never break the page
  }
}
